<template>
	<div class="w-full">
		<div
			class="relative mt-8 flex h-[480px] flex-col overflow-clip rounded bg-[#98BEA1] py-8 sm:h-[200px] sm:flex-row md:items-center md:justify-center md:gap-8"
		>
			<CarbarImage
				image="img/campaigns/may-savings-2025/shadow.webp"
				alt-text="May Savings!"
				image-width-class="w-[345px] sm:w-[200px] md:w-[345px] xl:w-[500px]"
				image-height-class="h-auto"
				class="absolute left-0 top-[140px] opacity-60 sm:top-[110px]"
			/>
			<div
				class="relative flex w-full items-center justify-center sm:w-[200px] md:w-[220px]"
			>
				<div class="relative h-[200px] w-full">
					<div
						class="relative 2xs:left-10 sm:-left-3 sm:top-8 md:left-10"
					>
						<Transition name="slide-fade-down">
							<CarbarImage
								v-if="showImage"
								image="img/campaigns/may-savings-2025/percentage.webp"
								alt-text="May Savings!"
								image-width-class="w-[175px] sm:w-[120px] md:w-[140px]"
								image-height-class="h-auto"
								class="absolute left-20 md:-top-[10px] md:left-[50px]"
							/>
						</Transition>
						<Transition name="slide-fade-down">
							<CarbarImage
								v-if="showImage"
								image="img/campaigns/may-savings-2025/percentage.webp"
								alt-text="May Savings!"
								image-width-class="w-[175px] sm:w-[120px] md:w-[140px]"
								image-height-class="h-auto"
								class="scale-up-fade-out absolute left-20 md:-top-[10px] md:left-[50px]"
							/>
						</Transition>
						<Transition name="slide-fade-left">
							<CarbarImage
								v-if="showImage"
								image="img/campaigns/may-savings-2025/car-money.webp"
								alt-text="May Savings!"
								image-width-class="w-[263px] sm:w-[200px] md:w-[220px]"
								image-height-class="h-auto"
								class="relative left-0 top-0 sm:-top-2 sm:left-4 md:-left-[18px] md:-top-[18px]"
							/>
						</Transition>
					</div>
				</div>
			</div>

			<div
				class="mt-4 flex flex-col px-1 text-center sm:mt-0 sm:text-left"
			>
				<div
					class="flex flex-col items-center gap-1 sm:items-start sm:px-4"
				>
					<p
						class="px-8 pb-1.5 font-heading text-[2rem] leading-none text-white sm:px-0 sm:text-[1.9rem] lg:text-[2.5rem]"
					>
						May we help you save?
					</p>
					<p class="px-8 text-xl font-medium text-white sm:px-0">
						Enjoy flexible, hassle-free driving this May!
					</p>
					<div
						class="mt-2 w-full max-w-fit overflow-clip rounded-full bg-white shadow-lg"
					>
						<div class="flex h-fit flex-row items-center">
							<span
								class="h-full w-full max-w-fit bg-blue-400 px-2 py-1 text-base font-medium text-white 2xs:px-4"
							>
								$150 OFF
							</span>
							<span
								class="h-full w-full max-w-fit px-2 py-1 text-base font-medium text-blue-400 2xs:px-4"
							>
								Use code "MAYSAVINGS"
							</span>
						</div>
					</div>
					<TermsAndConditions
						:is-full-width="false"
						custom-class="text-left mt-2"
						font-color="text-white"
					>
						*
						<CarbarLink
							text="Terms & conditions"
							text-color="text-white hover:text-gray-200"
							underline-color="hover:decoration-gray-200"
							font-size="text-xsm"
							class="cursor-pointer"
							@click="
								goToPageAndScroll(
									'/terms-and-conditions',
									'#may-savings-promotion',
									true
								)
							"
						/>
						apply
					</TermsAndConditions>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const showImage = ref(false)

onMounted(() => {
	setTimeout(() => {
		showImage.value = true
	}, 100)
})
</script>
